import React from 'react'
import { Tooltip } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import { BiAddToQueue } from 'react-icons/bi'
import i18next from 'i18next'

const styles = () => ({
  icon: {
    cursor: 'pointer',
    fontSize: 18,
    '&:hover': {
      opacity: 0.8,
    },
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
  },
})

const AddNewTask = ({ classes, noFSPanelProps }) => {
  const { showAddNewTask, newTaskFormOpener } = noFSPanelProps
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <Tooltip title={rtl ? 'إضافة مهمة جديدة' : 'Add New Task'}>
      <span
        className={classes.iconWrapper}
        style={{ display: showAddNewTask ? null : 'none' }}
        onClick={() => newTaskFormOpener()}
      >
        <BiAddToQueue className={classes.icon} />
      </span>
    </Tooltip>
  )
}

const WrappedAddNewTask = withStyles(styles)(AddNewTask)

export default WrappedAddNewTask
